import banner from "./banner";
import learningZone from "./learningZone";
import alibanner from "./alibanner";
import productBanner from "./productBanner";
import zxqyBanner from "./zxqyBanner";
export default [banner, learningZone, alibanner, productBanner, zxqyBanner];
